//获取部门员工信息
import { getUserListByDepartmentIdAPI } from '@/apis/user'
import { useState, useEffect } from 'react'

function useUserListDepartment(departmentId) {
    const [userList, setUserList] = useState([])

    useEffect(() => {
        const getCompanyList = async () => {
            const res = await getUserListByDepartmentIdAPI(departmentId)
            setUserList(res.data)
        }
        getCompanyList()
    }, [departmentId])
    return {
        userList
    }
}

export { useUserListDepartment } 